import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from '../../../services/api';
import { LIST_SEGMENT_REQUEST } from '../../actions';
import { listSegmentSuccess, listSegmentError } from './actions';

function* listSegment() {
  try {
    const response = yield call(api.get, 'segments');
    yield put(listSegmentSuccess(response.data.data));
  } catch (error) {
    yield put(listSegmentError(error));
  }
}

export default function* rootSaga() {
  yield all([takeLatest(LIST_SEGMENT_REQUEST, listSegment)]);
}
